import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, Typography, Divider } from "@mui/material";
import { Stack, Button, FormControlLabel, Checkbox } from "@mui/material";
import Repo from "../../Repository/Repo";
import { colsData } from "./ColsData";

function Customization({ onClose }) {
  let existingCols = localStorage.getItem("barcodeCols") || "";
  const [colsNames, setColsNames] = useState({});
  const [customCols, setCustomCols] = useState([]);
  co

  useEffect(() => {
    getFieldsNames();
    if (existingCols) {
      let existing = JSON.parse(existingCols);
      setColsNames(existing);
    } else {
      setColsNames((prev) => ({ ...prev, name: "name" }));
    }
  }, []);

  const getFieldsNames = async () => {
    try {
      let { data } = await Repo.default({
        request: {
          method: "getItemFields",
          data: {
            company_code: localStorage.getItem("companyCode"),
          },
        },
      });
      if (data.response.status.statusCode == 200) {
        if (data.response.data.itemFields.customFields) {
          setCustomCols(data.response.data.itemFields.customFields);
        } else {
          setCustomCols([]);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleInput = (e) => {
    const { name, checked } = e.target;
    if (checked) {
      if (colsNames[name]) {
        const copy = { ...colsNames };
        delete copy[name];
        setColsNames(copy);
      } else {
        setColsNames((prev) => ({ ...prev, [name]: name }));
      }
    } else {
      const copy = { ...colsNames };
      delete copy[name];
      setColsNames(copy);
    }
  };

  const handleSubmit = async () => {
    try {
      localStorage.setItem("barcodeCols", JSON.stringify(colsNames));
      onClose();
    } catch (err) {
      console.log(err);
      onClose();
    }
  };

  const getName = (e) => {
    for (const key in e) {
      if (key != "type") {
        return key;
      }
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <Stack spacing={3}>
          <Typography variant="h6">Customize</Typography>

          <Stack direction="row" flexWrap="wrap">
            <FormControlLabel
              control={<Checkbox name="name" checked disableRipple />}
              label="Name"
            />
          </Stack>
          <Divider>Optional Columns</Divider>

          <Stack direction="row" flexWrap="wrap">
            {colsData.map((item, i) => {
              return (
                <FormControlLabel
                  key={i}
                  control={
                    <Checkbox
                      name={item.title}
                      checked={colsNames[item.title] ? true : false}
                      disableRipple
                      onChange={handleInput}
                    />
                  }
                  label={<Typography>{item.label}</Typography>}
                />
              );
            })}
          </Stack>
          <Divider>Custom Columns</Divider>
          <Stack direction="row" flexWrap="wrap">
            {customCols.map((item, i) => {
              let name = getName(item);
              return (
                <FormControlLabel
                  key={i}
                  control={
                    <Checkbox
                      name={name}
                      checked={colsNames[name] ? true : false}
                      disableRipple
                      onChange={handleInput}
                    />
                  }
                  label={
                    <Typography sx={{ textTransform: "capitalize" }}>
                      {name}
                    </Typography>
                  }
                />
              );
            })}
          </Stack>

          <Stack direction="row" width="100%" justifyContent="space-between">
            <Button
              variant="contained"
              sx={{
                textTransform: "none",
                background: "#999 !important",
                color: "#fff",
              }}
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              sx={{ textTransform: "none" }}
              onClick={handleSubmit}
            >
              Update
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

export default Customization;
